export const foodCategoryAssociationTypes = ["isA", "contains"] as const;

// These should match the keys in the seed data
// Add more keys here needed for domain logic
export const foodCategoryKeys = {
  prepared: "prepared",
  fruit: "fruit",
  vegetable: "vegetable",
  poultry: "poultry",
  seafood: "seafood",
  egg: "egg",
  dairy: "dairy",
  grain: "grain",
  legume: "legume",
  nutSeed: "nut_seed",
  herbSpice: "herb_spice",
} as const;

export type FoodCategoryKey = (typeof foodCategoryKeys)[keyof typeof foodCategoryKeys];
